class DataLayer {
    constructor() {
        if (
            typeof Settings.services['gtm'] !== 'undefined' &&
            Settings.services['gtm']['enabled'] === true
        ) {
            this.dataLayer = window['dataLayer'] || (window['dataLayer'] = []);
            this.isEnabled = true;
        } else {
            this.dataLayer = [];
            this.isEnabled = false;
        }
    }

    push(event) {
        return new Promise((resolve, reject) => {
            if (!this.isEnabled) {
                return resolve('DataLayer is not enabled.');
            }

            try {
                resolve(this.dataLayer.push(event));
            } catch (error) {
                reject(error);
            }
        });
    }

    async addToCart(product, productVariant, addOnVariants, currency) {
        let addOnDataLayerProducts = [];

        addOnVariants.forEach(addOnVariant => {
            let variantToAddToCart = addOnVariant.variants.find(
                variant => variant.slug == productVariant.slug
            );

            variantToAddToCart = variantToAddToCart ? variantToAddToCart : addOnVariant.variants[0];

            addOnDataLayerProducts.push({
                id: addOnVariant.shopify_id,
                variantId: variantToAddToCart.shopify_id,
                priceInCents: variantToAddToCart.price.amountInCents,
                productType: addOnVariant.product_type,
            });
        });
        await this.push({
            event: 'Add to Cart',
            product: {
                id: product.shopify_id,
                variantId: productVariant.shopify_id,
                productType: product.product_type,
                priceInCents: productVariant.price.amountInCents,
            },
            addOnProducts: addOnDataLayerProducts,
            currency: currency,
        });
    }
}

export default new DataLayer();
